export default "__VITE_ASSET__C8oCLA78__"